module.exports = __webpack_public_path__ + "img/dialog-bg.5ef999ef.png";